import * as THREE from 'three'
import { render } from 'react-dom'
import './styles.css'
import { useRef, Suspense, useEffect, useState } from 'react'
import { Canvas, useFrame, useThree, extend } from '@react-three/fiber'
import { Center, OrbitControls, Instances, Instance } from '@react-three/drei'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { AfterimagePass } from 'three/examples/jsm/postprocessing/AfterimagePass'

import allColors from './Colors'

let lerp = THREE.MathUtils.lerp
let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]

let cIndexes = new Array(allColors.length).fill().map((_, i) => i)
let ci = cIndexes.splice(randI(cIndexes.length), 1)[0]
let ci2 = cIndexes.splice(randI(cIndexes.length), 1)[0]
let ci3 = cIndexes.splice(randI(cIndexes.length), 1)[0]
let cols = allColors[ci]
let cols2 = allColors[ci2]
let cols3 = allColors[ci3]
let bg = cols.shift()
cols2.shift()
cols3.shift()
cols = [...cols, ...cols2,...cols3]

let started = false
let down = false
let startTime = false
let time = false

const mouseDown = () => {
  down = true
  startTime = 0
}
const mouseUp = () => {
  c = 0
  if ((time - startTime) < 0.2) {
    damp = 0
    visible = new Array(dim).fill().map(() => new Array(dim).fill(true))
  } else {
    damp = 0.99
    new Array(20).fill().map(() => (visible[randI(dim)][randI(dim)] = false))
    visible[randI(dim)][randI(dim)] = true
  }
  down = false
}
const mouseMove = () => {
  if (down) {
    if ((randI(100) < ((dim * 30) / movesAmt)) && (remaining > minRemaining)) {
      visible[randI(dim)][randI(dim)] = false
      remaining = 0
      visible.forEach((v) => v.forEach((v2) => {
        v2 && remaining++
      }))
    }
  }
}
const smallScreen = window.innerWidth < 800
let overlayColor = (randI(100) < 80) ? 'black' : ((randI(100) < 20) ? 'white' : 'blue')
let first = true
export default function App() {
  const size = useWindowSize();
  useEffect(() => {
    if (!first) {
      c = 0
    } else {
      first = false
    }
  }, [size.width])
  const ref = useRef()
  return (
    <div id="main"
      onMouseDown={() => mouseDown()}
      onTouchStart={() => mouseDown()}
      onMouseMove={() => mouseMove()}
      onTouchMove={() => mouseMove()}
      onMouseUp={() => mouseUp()}
      onTouchEnd={() => mouseUp()}
      key={size.width}
    >
      <Canvas flat={true} linear={true} dpr={[1, 2]} camera={{
        near: 0.000001, far: 10000, position: [0, 0, smallScreen ? 20 : 15], fov: 50,
      }}
        gl={{ alpha: false, antialias: false, stencil: false, depth: false }}
      >
        <color attach="background" args={[bg]} />
        <Grids />
        <Tint />
        <ambientLight intensity={0.9} />
        <directionalLight intensity={1} position={[-1, 1, -1]} />
        <OrbitControls ref={ref} enableDamping={true} dampingFactor={0.01} touches={{ ONE: THREE.TOUCH.PAN }} mouseButtons={{
          LEFT: THREE.MOUSE.PAN,
          RIGHT: THREE.MOUSE.PAN,
        }} enableRotate={false} />
      </Canvas>
      <div id="overlay" style={{ background: overlayColor }} />
    </div>
  )
}

let sp = 0.18
let currSp = 0
let sc = 0.00018
let currSc = 0
let movesAmt = 4 + randI(7)
let dim = 22 - movesAmt
let c = 0
let pos = []
let rot = []
let moves = 800

let remaining = dim * dim
let minRemaining = rand([2, 3])

let addPos = (i) => pos.push([
  randI(2 + randI(7)) * [1, -1][i % 2],
  randI(1 + randI(7)) * rand([1, -1]),
])

let addRot = () => rot.push([
  (0.1 + randI(3 + randI(20))) * rand([1, -1]),
  (0.1 + randI(3 + randI(20))) * rand([1, -1]),
])
let genMoves = (doPos) => {
  pos = []
  rot = []
  addPos(0)
  addRot()
  new Array(movesAmt + 1).fill().forEach((_, i) => {
    if (doPos) {
      addPos(i + 1)
      addRot()
    }
  })
}
let visible = new Array(dim).fill().map(() => new Array(dim).fill(true))
genMoves(true)
let transMat = new THREE.MeshBasicMaterial({ opacity: 0, transparent: true })
function Grids() {
  useFrame((e) => {
    if (startTime == 0) {
      startTime = e.clock.getElapsedTime()
    }
    time = e.clock.getElapsedTime()

    let fr = (1 - Math.pow(1 - (((c) % moves) / moves), 2))
    if (device && device2) {
      let d1 = 1400
      let d2 = d1 * 0.75
      device.parameters[3].value = d1 * 0.5
      device.parameters[5].value = d2 * 0.5
      device2.parameters[3].value = d2 * 0.5 * 0.5
      device2.parameters[5].value = d1 * 0.5 * 0.5

      device.parameters[1].value = (1.01 - fr) * 2600
      device2.parameters[1].value = (1.01 - fr) * 2600
    }
  })
  return (
    <Center>
      <group rotation={[0, 0, randI(0) * Math.PI * 0.1]}>
        <Instances limit={100000} geometry={new THREE.OctahedronBufferGeometry(0.5, 2)} material={new THREE.MeshStandardMaterial({ depthTest: false, depthWrite: false })}>
          {new Array(movesAmt).fill().map((_, i) => <Grid gi={i} key={i} />)}
        </Instances>
        <>
          {new Array(movesAmt + 1).fill().map((_, i) => <mesh scale={2} geometry={new THREE.BoxBufferGeometry()} material={transMat} position={[pos[i][0], pos[i][1], 0]} key={i} />)}
        </>
      </group>
    </Center>
  )
}
let currPosArr = []
let currRotArr = []
let gFr = 0

let dimOffset = new Array(movesAmt).fill().map((_, i) => randI([11]))
function Grid({ gi }) {
  const ref = useRef()
  useFrame((s) => {
    gFr = (1 - Math.pow(1 - ((c % moves) / moves), 6))

    let i = (Math.floor((c + 1) / moves) + gi) % movesAmt
    let ni = (i + 1) % movesAmt

    let fr = (1 - Math.pow(1 - (((c) % moves) / moves), 8))

    currPosArr[gi] = [
      lerp(pos[i][0], pos[ni][0], fr),
      lerp(pos[i][1], pos[ni][1], fr),
    ]
    currRotArr[gi] = [
      lerp(rot[i][0], rot[ni][0], fr),
      lerp(rot[i][1], rot[ni][1], fr),
    ]

    ref.current.position.x = currPosArr[gi][0]
    ref.current.position.y = currPosArr[gi][1]
    ref.current.rotation.y = currRotArr[gi][0]
    ref.current.rotation.z = currRotArr[gi][1]
  })
  return (
    <group ref={ref}>
      {new Array(dim-dimOffset[gi]).fill().map((_, x) =>
        new Array(dim-dimOffset[gi]).fill().map((_, y) =>
          <Thang x={x} y={y} gi={gi} key={x + y} />
        )
      )}
    </group>
  )
}
let gridCols = new Array(movesAmt).fill().map(() => new Array(Math.floor(movesAmt * rand([0.6, 0.7, 0.5, 0.5, 1,1, 2, 3]))).fill().map(() => rand(cols)))
let spRads = new Array(movesAmt).fill().map(() => rand([1, 1.5, 2, 4, 0.6, 0.4, 0.2, 0.1]))
function Thang({ x, y, gi }) {
  const ref = useRef();
  const refX = useRef()
  const refY = useRef()
  const spTarget = useRef(randI(12) * 0.25)

  useFrame(() => {
    currSp = Math.sin(lerp(0, spTarget.current, gFr) * Math.PI * spRads[gi]) * sp * 0.75
    currSc = lerp(sc * 0.05, down ? sc * (0.4 * (1 - gFr)) : sc*1.4, gFr) * (currDist * currDist * 0.45)
    refX.current.position.x = x * currSp
    refY.current.position.y = y * currSp
    ref.current.scale.setScalar((0.02 + (Math.sin(gFr * Math.PI * 6 + ((x + y) / 4)) * currSc)) * ((visible[x][y] && started) ? 1 : 0))
  })
  return (
    <group ref={refX} position={[x * currSp, 0, 0]}>
      <group ref={refY} position={[0, y * currSp, 0]}>
        <Instance color={rand(gridCols[gi])} ref={ref} />
      </group>
    </group>
  )
}

let damp = 1
let currDist = 0
let vec = new THREE.Vector3()
const Tint = () => {
  let r = useRef(), { size: e, gl: n, scene: a, camera: d } = useThree(), s = useRef(); return useFrame(() => {
    if (c < (moves - 1) && started) {
      c++;
    }
    if (device && device2) {
      device.parameters[2].value = 1.002 + (-d.position.y / 40)
      device2.parameters[2].value = 1.001 + (-d.position.y / 40)
      device.parameters[0].value = 1.0 + Math.abs(d.position.x / 4)
      device2.parameters[0].value = 1.0 + Math.abs(d.position.x / 4)
    }
    currDist = d.position.distanceTo(vec)*0.8
    r.current.uniforms.damp.value = damp;
    s.current.render();
    if (damp !== 1) {
      note = rand(instNotes)
      noteOn()
      noteOff()
      damp = 1
    }
  }, 1), <effectComposer ref={s} args={[n]}><renderPass attachFns={["addPass"]} args={[a, d]} /><afterBurn attachFns={["addPass"]} args={[e]} ref={r} /></effectComposer>
}
class AfterBurn extends AfterimagePass { constructor() { super(1); this.shaderMaterial.onBeforeCompile = (shader) => { shader.fragmentShader = `uniform float damp;uniform sampler2D tOld;uniform sampler2D tNew;varying vec2 vUv;vec4 when_gt( vec4 x, float y ) {return max( sign( x - y ), 0.000000001 );} void main() { vec4 texelOld = texture2D( tOld, vUv ); vec4 texelNew = texture2D( tNew, vUv ); texelOld *= damp * when_gt( texelOld, 0.0000000001 );gl_FragColor = max(texelNew, texelOld);}` } } }
extend({ EffectComposer, RenderPass, AfterBurn })
function useWindowSize() { let [e, i] = useState({ width: void 0, height: void 0 }); return useEffect(() => { function e() { i({ width: window.innerWidth, height: window.innerHeight }) } return window.addEventListener("resize", e), e(), () => window.removeEventListener("resize", e) }, []), e }

render(
  <Suspense fallback={null}><App /></Suspense>,
  document.getElementById('root')
)

//RNBO
const instNotes = []
let scales = ['C', 'D', 'E', 'F', 'G', 'A']
let octs = [3]
scales.map((n) => {
  octs.map((o) => {
    instNotes.push(n + o)
  })
})

let device, device2;
async function setup() {
  const patchExportURL = "export/patch.export.blocks.json";

  const WAContext = window.AudioContext || window.webkitAudioContext;
  const context = new WAContext();

  const outputNode = context.createGain();
  outputNode.gain.value = 0.1
  outputNode.connect(context.destination);

  let response, patcher;
  response = await fetch(patchExportURL);
  patcher = await response.json();

  if (!window.RNBO) {
    await loadRNBOScript(patcher.desc.meta.rnboversion);
  }

  device = await RNBO.createDevice({ context, patcher });
  device2 = await RNBO.createDevice({ context, patcher });
  started = true
  device.parameters[6].value = 3000
  device2.parameters[6].value = 3000
  device.parameters[8].value = 1
  device2.parameters[8].value = 1
  device.parameters[9].value = 20000
  device2.parameters[9].value = 20000
  device.parameters[4].value = 0.9
  device2.parameters[4].value = 0.9

  device.node.connect(outputNode);
  device2.node.connect(outputNode);

  document.body.onclick = () => {
    context.resume();
  }
}

function loadRNBOScript(version) {
  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = "./rnbo.min.js";
    el.onload = resolve;
    document.body.append(el);
  });
}

let note = ''
function noteOn(dur) {
  let noteOnMessage = [
    144,
    noteToMidi(note) - 0,
    1
  ];
  let noteOnEvent = new RNBO.MIDIEvent((device.context.currentTime * 1000) + 0, 0, noteOnMessage);
  device.scheduleEvent(noteOnEvent);
  device2.scheduleEvent(noteOnEvent);
}
function noteOff() {
  let noteOffMessage = [
    128,
    noteToMidi(note) - 0,
    0];
  let noteOffEvent = new RNBO.MIDIEvent((device.context.currentTime * 1000) + 200, 0, noteOffMessage);
  device.scheduleEvent(noteOffEvent);
  device2.scheduleEvent(noteOffEvent);
}

let allNotes = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"]
function noteToMidi(note) {
  let i = allNotes.indexOf(note[0])
  return 12 + (note[1] * 12) + i
}
setup();
console.log('%c 🕊️🕊️ @ramioso 2022-12-13 🦅🦅', 'color: orange');
const feats = window.$fxhashFeatures = {
  background: overlayColor,
  birds: movesAmt,
}